import { GOOGLE_MAP_API_KEY } from "./apiKeys";

const googleMapInitializer = {
    libraries: ["places"],
    id: "google-map-script",
    googleMapsApiKey: GOOGLE_MAP_API_KEY,
};

export default googleMapInitializer;
